export function isPreviewHost() {
  return window.location.hostname.includes('.vercel.app');
}

export async function clearBrowserCaches() {
  let hadCachedState = false;

  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    hadCachedState ||= registrations.length > 0 || Boolean(navigator.serviceWorker.controller);
    await Promise.all(
      registrations.map(async (registration) => {
        await registration.update().catch(() => null);
        return registration.unregister();
      }),
    );
  }

  if ("caches" in window) {
    const cacheNames = await caches.keys();
    hadCachedState ||= cacheNames.length > 0;
    await Promise.all(cacheNames.map((cacheName) => caches.delete(cacheName)));
  }

  return hadCachedState;
}

export async function clearPreviewCachesAndReloadOnce(resetKey: string) {
  const alreadyReset = sessionStorage.getItem(resetKey) === "done";
  const hadCachedState = await clearBrowserCaches();

  if (!alreadyReset && hadCachedState) {
    sessionStorage.setItem(resetKey, "done");
    window.location.replace(`${window.location.pathname}${window.location.search}${window.location.hash}`);
    return true;
  }

  sessionStorage.removeItem(resetKey);
  return false;
}

export async function clearBrowserCachesAndReload(targetVersion?: string) {
  await clearBrowserCaches();

  const url = new URL(window.location.href);
  url.searchParams.set("__cb", Date.now().toString());

  if (targetVersion) {
    url.searchParams.set("__appv", targetVersion);
  }

  window.location.replace(url.toString());
}

async function revalidateServiceWorker(
  swUrl: string,
  registration: ServiceWorkerRegistration,
) {
  await fetch(swUrl, {
    cache: "no-store",
    headers: {
      "cache-control": "no-cache",
    },
  }).catch(() => null);

  // registration.update() can reject with "Not found" / "Failed to update" on
  // headless or short-lived browser sessions (Vercel preview crawlers, lighthouse
  // bots) — never let it bubble up as an unhandled rejection.
  await registration.update().catch(() => null);
}

export function startServiceWorkerUpdateChecks(
  swUrl: string,
  registration: ServiceWorkerRegistration,
) {
  void revalidateServiceWorker(swUrl, registration).catch(() => null);

  return window.setInterval(() => {
    void revalidateServiceWorker(swUrl, registration).catch(() => null);
  }, 60 * 1000);
}